import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getTypes = createAction(
  'GET_TYPES',
  () => api.get('types'),
  identifier => ({ identifier })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/types.js